import { render, staticRenderFns } from "./DialogEditClassSetup.vue?vue&type=template&id=91155d60"
import script from "./DialogEditClassSetup.vue?vue&type=script&lang=js"
export * from "./DialogEditClassSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports